/**
 * Training Grounds: one open room for M0/M1 tests. A four-mob pack with a bolt caster
 * and a frontal (PLAN §9 M1), plus a training dummy off to the side.
 */
import type { DungeonDef } from '@keystone/sim';
import { DUNGEON, NPC } from '../ids';
import { cluster } from './geometry';

const room = { points: [{ x: -20, y: -30 }, { x: 100, y: -30 }, { x: 100, y: 30 }, { x: -20, y: 30 }] };
const entrance = { x: 0, y: 0 };

export const trainingGrounds: DungeonDef = {
  id: DUNGEON.trainingGrounds,
  name: 'Training Grounds',
  timerMs: 5 * 60 * 1000,
  forcesRequired: 24,
  entrance,
  entranceFacing: 0,
  rooms: [{ id: 'arena', name: 'Arena', shape: room }],
  corridors: [],
  packs: [
    {
      id: 'tg_pack1',
      roomId: 'arena',
      aggroRadius: 10,
      socialRadius: 15,
      spawns: cluster({ x: 40, y: 0 }, [NPC.fangReaver, NPC.cultAdept, NPC.spittingSerpent, NPC.fangReaver], entrance),
    },
    {
      id: 'tg_dummy',
      roomId: 'arena',
      aggroRadius: 0,
      spawns: [{ npcId: NPC.trainingDummy, pos: { x: 80, y: 20 }, facing: Math.PI }],
    },
  ],
  route: ['tg_pack1'],
  requiredEncounters: [],
  bounds: { x: -20, y: -30, w: 120, h: 60 },
};
